import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { GetAccountDetail_account } from '../../queries/generated/GetAccountDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-advanced-account-settings-view',
    styleUrls: ['./advanced-account-settings-view.component.scss'],
    templateUrl: './advanced-account-settings-view.component.html',
    standalone: false
})
export class AdvancedAccountSettingsViewComponent {
   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() account: GetAccountDetail_account | null;

   @Input() title: string;

   @Output() formSubmitted = new EventEmitter<any>();

   @Output() formCanceled = new EventEmitter<void>();

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
